module.exports = __webpack_public_path__ + "static/media/hamburger.f5f50b66.svg";